import { lazyWithRetry } from 'utils/lazyWithRetry';

export const ProjectListV2Page = lazyWithRetry(() =>
  import('./list-v2').then((module) => ({
    default: module.ProjectListV2Page,
  })),
);

export const ProjectDetailRoute = lazyWithRetry(() =>
  import('./detail').then((module) => ({
    default: module.ProjectDetailRoute,
  })),
);

export const ProjectSettings = lazyWithRetry(() =>
  import('./settings').then((module) => ({
    default: module.ProjectSettings,
  })),
);

export const ProjectOverviewPage = lazyWithRetry(() =>
  import('components/organisms/projects/project-overview').then((module) => ({
    default: module.ProjectOverviewPage,
  })),
);

export const ProjectFinancialsRoute = lazyWithRetry(() =>
  import('./detail/financials').then((module) => ({
    default: module.ProjectFinancialsRoute,
  })),
);

export const ProjectPlanPage = lazyWithRetry(() =>
  import('./detail/plan').then((module) => ({
    default: module.ProjectPlanPage,
  })),
);

export const ProjectSpacesPage = lazyWithRetry(() =>
  import('components/pages/project-details/project-spaces/project-spaces').then(
    (module) => ({
      default: module.ProjectSpacesPage,
    }),
  ),
);

export const RedirectToSpaceTabById = lazyWithRetry(() =>
  import('./detail/spaces/spaces').then((module) => ({
    default: module.RedirectToSpaceTabById,
  })),
);

export const RedirectToSpaceById = lazyWithRetry(() =>
  import('./detail/spaces/spaces').then((module) => ({
    default: module.RedirectToSpaceById,
  })),
);

export const ProjectConversationPage = lazyWithRetry(() =>
  import('./detail/conversation').then((module) => ({
    default: module.ProjectConversationPage,
  })),
);

export const ProjectConversationPageResponsive = lazyWithRetry(() =>
  import('./detail/conversation-responsive').then((module) => ({
    default: module.ProjectConversationPageResponsive,
  })),
);

export const ProjectTasksPage = lazyWithRetry(() =>
  import('components/pages').then((module) => ({
    default: module.ProjectTasksPage,
  })),
);

export const ProjectStatusUpdatesPage = lazyWithRetry(() =>
  import('./detail/status-updates').then((module) => ({
    default: module.ProjectStatusUpdatesPage,
  })),
);

export const FormResponseLandingPage = lazyWithRetry(() =>
  import('components/pages/project-details/form-responses').then((module) => ({
    default: module.FormResponseLandingPage,
  })),
);

export const ProjectFilesPage = lazyWithRetry(() =>
  import('./detail/files').then((module) => ({
    default: module.ProjectFilesPage,
  })),
);

export const ProjectTaskListPage = lazyWithRetry(() =>
  import('components/pages/task-list/list').then((module) => ({
    default: module.ProjectTaskListPage,
  })),
);

export const ProjectTaskListPageV2 = lazyWithRetry(() =>
  import('components/pages/task-list/task-list').then((module) => ({
    default: module.ProjectTaskListPageV2,
  })),
);
